<template>
  <div v-if="!!subscriptionCount" class="blocco_sfumato cf cancel-button">
    <div class="titolo title">Abbonamenti Blog</div>
    <div class="row-fluid">
      <DxDataGrid
        id="gridContainer"
        :ref="bannerDataGrid"
        :data-source="gridItems"
        :allow-column-reordering="false"
        :show-borders="false"
        class="test"
      >
        <DxPager
          :show-page-size-selector="true"
          :allowed-page-sizes="[10, 20, 50]"
          :show-navigation-buttons="true"
          :show-info="true"
          :info-text="'Pagina {0} di {1} ({2} elementi)'"
        />
        <DxPaging :page-size="10" />
        <DxColumn
          caption="Descrizione"
          data-field="subscriptionDescription"
          data-type="string"
          width="30%"
        />
        <DxColumn
          caption="Tipologia"
          data-field="subscriptionType"
          alignment="center"
          data-type="string"
        />
        <DxColumn
          caption="Data Attivazione"
          data-field="startDate"
          alignment="center"
          data-type="date"
          format="dd/MM/yyyy"
        />
        <DxColumn
          caption="Data Rinnovo"
          alignment="center"
          data-field="endDate"
          data-type="date"
          format="dd/MM/yyyy"
        />
        <DxColumn
          caption="Disdetta"
          cell-template="viewCancellationDialog"
          alignment="center"
        />
        <template #viewCancellationDialog="{ data }">
          <DxButton
            v-if="checkIsExpired(data.data)"
            :width="120"
            text="Abbonati"
            type="normal"
            styling-mode="text"
            @click="redirectToSubscribe()"
          />
          <span v-else-if="data.data.cancellationId">Disdetta inviata</span>
          <DxButton
            v-else
            :width="120"
            text="Disdetta"
            type="normal"
            styling-mode="text"
            @click="openConfirmModal(data)"
          />
        </template>
      </DxDataGrid>
    </div>
    <DxPopup
      v-model:visible="popupVisible"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      :show-close-button="true"
      :show-title="true"
      class="dialog-confirmation"
      title="Attenzione"
      width="50%"
      height="50%"
    >
      <DxPosition at="center" my="center" of="positionOf" collision="fit" />
      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="submitUnsubscription"
      />
      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="closeButtonOptions"
      />
      <p>
        <span>
          Se dai disdetta all’abbonamento perderai l’accesso a
          <b>tutti i tuoi vantaggi:</b>
          <ul>
            <li>
              non potrai più
              <b>
                consultare liberamente l’archivio completo con tutti gli
                articoli
              </b>
              di Euroconference News
            </li>
            <li>
              non avrai più la possibilità di
              <b>effettuare il download in pdf</b> di tutti gli articoli di
              Euroconference News
            </li>
            <li>
              non riceverai più sulla tua casella di posta la
              <b>newsletter quotidiana</b> che ti permette di
              <b>restare sempre aggiornato sulle novità di periodo.</b>
            </li>
          </ul>
        </span>
      </p>
      <div class="pl-25">
        <span>
          Ti ricordiamo che hai la possibilità di dare disdetta entro 7 giorni
          dalla data di rinnovo in caso di abbonamento mensile e entro 60 giorni
          dalla data di rinnovo in caso di abbonamento annuale.
        </span>
        <span v-if="spanProssimoRinnovo">
          <br />
          <b class="warning-text">
            La richiesta di disdetta è oltre i termini previsti per
            l’abbonamento in corso, verrà quindi presa in carico a partire dal
            prossimo rinnovo.
          </b>
        </span>
        <p class="main-message">
          <span>
            Sei sicuro di voler perdere tutti i vantaggi e procedere ed inviare
            la disdetta dell’abbonamento?
          </span>
        </p>
      </div>
    </DxPopup>
  </div>
  <div v-else class="blocco_sfumato cf cancel-button">
    <div class="titolo">Abbonamenti Blog</div>
    <div class="row-fluid">
      <p class="t-center">
        <span>
          Non sono presenti abbonamenti a Euroconference News attivi.
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import CustomStore from 'devextreme/data/custom_store'
import DxButton from 'devextreme-vue/button'
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxPager,
} from 'devextreme-vue/data-grid'
import { DxPopup, DxPosition, DxToolbarItem } from 'devextreme-vue/popup'

export default {
  name: 'EcSubscriptionBlogList',
  components: {
    DxDataGrid,
    DxColumn,
    DxPopup,
    DxPosition,
    DxToolbarItem,
    DxButton,
    DxPaging,
    DxPager,
  },
  data() {
    const userId = localStorage.getItem('UserID')
    return {
      subscriptionCount: null,
      bannerDataGrid: 'bannerDataGrid',
      popupVisible: false,
      spanProssimoRinnovo: false,
      positionOf: '',
      idToDelete: null,
      submitUnsubscription: {
        text: 'Invia disdetta',
        type: 'default',
        onClick: () => {
          this.apiService.blogSubscriptionsApi
            .deleteBlogSubscriptionByShopRigheTestataId(this.idToDelete)
            .then(() => {})
          this.popupVisible = false
          this.spanProssimoRinnovo = false
          this.idToDelete = null
          this.blogSubscriptionsListCount()
          this.gridItems.load().then(() => {
            this.$refs[this.bannerDataGrid].instance.refresh()
          })
        },
      },
      closeButtonOptions: {
        text: 'Annulla',
        type: 'normal',
        onClick: () => {
          this.popupVisible = false
          this.spanProssimoRinnovo = false
          this.idToDelete = null
        },
      },
      gridItems: new CustomStore({
        load: () =>
          this.apiService.blogSubscriptionsApi.getBlogSubscriptionsByUserId(
            userId,
            false
          ), // 4632
      }),
    }
  },

  created() {
    this.blogSubscriptionsListCount()
  },

  mounted() {},

  methods: {
    blogSubscriptionsListCount() {
      const userId = localStorage.getItem('UserID')
      const self = this
      this.apiService.blogSubscriptionsApi
        .getBlogSubscriptionsCountByUserId(userId, false)
        .then(res => {
          self.subscriptionCount = res > 0
        })
    },
    openConfirmModal(data) {
      this.idToDelete = data.data.orderId
      this.popupVisible = true
      this.spanProssimoRinnovo =
        new Date(data.data.endDate) <
        new Date(
          new Date().setDate(
            new Date().getDate() + data.data.subscriptionTypeLengthLimit
          )
        )
    },

    redirectToSubscribe() {
      window.location.href = window.websiteConfig.blogSubscriptionUrl
    },

    checkIsExpired(data) {
      return data.EndDate < new Date()
    },
  },
}
</script>

<style scoped>
.table-header {
  text-transform: uppercase;
  text-align: left;
  background: #00a0dc;
  color: white;
  padding: 10px;
  font: 14px/14px pt_sansregular;
}
</style>
